import END_POINTS from './shopify-endpoints';

import { shopifyEnabledMarkets } from '../links.config';

const bannerLinksForTWAndVN = {
  vn: END_POINTS.ZENYUMFRESH_TOOTHPASTE,
  tw: END_POINTS.ZENYUMSONIC_GENTLE_STARTER_KIT
};

export const segmentTexts = {
  whitening: {
    category: '',
    product: ''
  },
  sonicgo: {
    category: 'Electric Toothbrush',
    product: 'SonicGo Toothbrush'
  },
  waterflosser: {
    category: 'Floss',
    product: 'Waterflosser Pro'
  },
  sonic: {
    category: 'Electric toothbrush',
    product: 'Sonic Toothbrush'
  },
  fresh: {
    category: 'Toothpaste and Mouthwash',
    product: 'Fresh Bundle'
  }
};

const bannerConfiguration = (product, country) => {
  const shopifyBannerLinks = { whitening: {
    buynow: END_POINTS.ZENYUMBRIGHT_INVISIBLE_WHITENING_FOURTEEN_STRIPS,
    learnmore: END_POINTS.ZENYUMBRIGHT_TEETH_WHITENING_STRIPS
  },
  sonicgo: {
    buynow: END_POINTS.ZENYUMSONIC_GO_TOOTHBRUSH,
    learnmore: END_POINTS.ZENYUMSONIC_ELECTRIC_TOOTHBRUSHES
  },
  waterflosser: {
    buynow: END_POINTS.ZENYUM_WATERFLOSSER_PRO,
    learnmore: END_POINTS.ZENYUMFLOSS
  },
  sonic: {
    buynow: END_POINTS.ZENYUMSONIC_TOOTHBRUSH,
    learnmore: END_POINTS.ZENYUMSONIC_ELECTRIC_TOOTHBRUSHES
  },
  fresh: {
    buynow: country === 'vn' || country === 'tw' ? bannerLinksForTWAndVN[country] : END_POINTS.ZENYUMFRESH_BUNDLE,
    learnmore: END_POINTS.TOOTHPASTE_AND_MOUTHWASH
  } };

  const bannerLinks = { whitening: {
    buynow: 'zenyumbright-teeth-whitening-strips-details',
    learnmore: 'zenyumbright-teeth-whitening-strips'
  },
  sonicgo: {
    buynow: 'zenyumsonicgo-details',
    learnmore: 'zenyumsonic-electric-toothbrushes'
  },
  waterflosser: {
    buynow: 'waterflosserpro-details',
    learnmore: 'zenyumfloss'
  },
  sonic: {
    buynow: 'zenyumsonic-details',
    learnmore: 'zenyumsonic-electric-toothbrushes'
  },
  fresh: {
    buynow: country !== 'vn' ? 'zenfresh-bundle-details' : 'zenfresh-toothpaste-day',
    learnmore: 'toothpaste-and-mouthwash'
  } };

  return shopifyEnabledMarkets.includes(country) ? shopifyBannerLinks[product] : bannerLinks[product];
};

export default bannerConfiguration;
